import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import DialogBox from "../../../../../components/DialogBox";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import { Box } from "@mui/system";
import {
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  createNewVisitQuestionnaireService,
  getQuestionnaireDropdownListService,
} from "../../../../../services/visits";
import { toast } from "react-toastify";
import {
  handleBackNavigationGeneralFun,
  handleBackNavigationWithId,
} from "../../../../../components/helpers/helper";

const CreateQuestionnaires = () => {
  const labelStyles = {
    display: "flex",
    alignItems: "center",
    height: "20px",
  };

  const textBoxBody = {
    marginLeft: "10px",
  };

  const textBoxStyles = {
    fontSize: 15,
    width: "500px",
    height: "10px",
    padding: "11px 14px",
  };

  const loadContainerStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
  };

  const selectStyles = {
    width: 530,
    marginTop: 1,
  };

  const rowStyles = {
    marginTop: "2%",
  };

  const buttonLinkStyle = {
    background: "none",
    color: "#337AB7",
    border: "none",
    padding: "0",
    font: "inherit",
    cursor: "pointer",
  };

  const createQuestionnaireSchema = yup.object().shape({
    questionnaireId: yup.string().required("This field is required"),
    sequence: yup
      .number()
      .typeError("Value must be a number")
      .required("This field is required")
      .min(0, "Value cannot be less than 0"),
    isAudioEnabled: yup.bool().oneOf([true, false]),
    isVideoEnabled: yup.bool().oneOf([true, false]),
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createQuestionnaireSchema),
  });

  const notify = () =>
    toast.success("Visit Questionnaire Created Successfully", {
      toastId: "form-creation",
    });

  const requestFailed = (msg) =>
    toast.error(`${msg}`, {
      toastId: "requestFailed",
    });

  const navigate = useNavigate();
  const location = useLocation();
  const id = location?.state?.id;

  const [load, setLoad] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);

  const [questionnaireDropdownList, setQuestionnaireDropdownList] = useState(
    []
  );

  useEffect(() => {
    if (id) {
      getQuestionnaireDropdownList(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    setLoad(true);
    console.log(data, "dara");
    // e.preventDefault();
    try {
      data.visitId = id;
      data.reviewQuestionnaireId = null;
      data.requiresReview = false;
      const res = await createNewVisitQuestionnaireService(data);
      if (res?.status) {
        notify();
        navigate(`/study-management/visits/visit-questionnaire`, {
          state: {
            id: id,
          },
        });
      }
    } catch (err) {
      console.log("Error: ", err.message);
      requestFailed(err?.message);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();

    if (showDialog) {
      const confirmExit = window?.confirm(
        "You have unsaved changes, Are you sure you want to leave?"
      );

      if (confirmExit) {
        navigate("/study-management/visits/visit-questionnaire", {
          state: {
            id: id,
          },
        });
      }
    } else {
      navigate("/study-management/visits/visit-questionnaire", {
        state: {
          id: id,
        },
      });
    }
  };

  const getQuestionnaireDropdownList = async (id) => {
    setLoad(true);
    try {
      const res = await getQuestionnaireDropdownListService(id);
      if (res?.status) {
        setQuestionnaireDropdownList(res?.data?.result?.questionnaires);
        setLoad(false);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error: ", err?.message);
    }
  };

  return (
    <>
      {load ? (
        <>
          <div style={loadContainerStyles}>
            <BeatLoader color="#3661eb" />
          </div>
        </>
      ) : (
        <div className="content-body">
          <p className="study-management-link" style={{ fontWeight: "600" }}>
            <button
              style={buttonLinkStyle}
              onClick={(e) =>
                handleBackNavigationGeneralFun(
                  e,
                  showDialog,
                  "study-management",
                  navigate
                )
              }
            >
              Manage Your Study
            </button>{" "}
            |{" "}
            <button
              style={buttonLinkStyle}
              onClick={(e) =>
                handleBackNavigationGeneralFun(
                  e,
                  showDialog,
                  "study-management/visits",
                  navigate
                )
              }
            >
              Visits
            </button>{" "}
            |{" "}
            <button
              style={buttonLinkStyle}
              onClick={(e) =>
                handleBackNavigationWithId(
                  e,
                  showDialog,
                  "study-management/visits/visit-questionnaire",
                  navigate,
                  id
                )
              }
            >
              Visit Questionnaires
            </button>{" "}
            | <button style={buttonLinkStyle}>Create Questionnaires</button>-{" "}
            <b style={{ color: "gray" }}>
              {sessionStorage?.getItem("studyName")}
            </b>
          </p>

          <div>
            <DialogBox
              showDialog={showPrompt}
              confirmNavigation={confirmNavigation}
              cancelNavigation={cancelNavigation}
            />
          </div>

          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{ height: "auto", width: "100%" }}
            autoComplete="off"
          >
            <div className="createVisitBody">
              <div className="createVisitHeader">
                <h1>Create Questionnaire</h1>
              </div>
              <div className="createVisitFormBody">
                <div className="createVisitInput">
                  <p style={labelStyles}>
                    Questionnaire Id
                    <span className="error-highlight">*</span>
                  </p>
                  <FormControl sx={selectStyles}>
                    <Select
                      name="questionnaireId"
                      defaultValue={""}
                      inputProps={{
                        style: textBoxStyles,
                        "aria-label": "Without label",
                        className: "custom-input-class",
                      }}
                      {...register("questionnaireId", {
                        onChange: (e) => {
                          setValue("questionnaireId", e.target.value, {
                            shouldValidate: true,
                          });
                          setShowDialog(true);
                        },
                      })}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {questionnaireDropdownList &&
                        questionnaireDropdownList?.map((item) => (
                          <MenuItem value={item?.id}>
                            <em>{item?.internalName}</em>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                {errors.questionnaireId && (
                  <>
                    <div className="createVisitFlexEnd">
                      <div className="createVisitError">
                        <span className="error-text" style={{ color: "red" }}>
                          {errors.questionnaireId.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}
                <div className="createVisitCheckbox">
                  <p>Is Audio Enabled</p>
                  <Checkbox
                    style={{ fontSize: "15px" }}
                    inputProps={{ "aria-label": "controlled" }}
                    {...register("isAudioEnabled", {
                      onChange: (e) => {
                        setShowDialog(true);
                      },
                    })}
                  />
                </div>

                {errors.isAudioEnabled && (
                  <>
                    <div className="createVisitFlexEnd">
                      <div className="createVisitError">
                        <span className="error-text" style={{ color: "red" }}>
                          {errors.isAudioEnabled.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}

                <div className="createVisitCheckbox">
                  <p>Is Video Enabled</p>
                  <Checkbox
                    style={{ fontSize: "15px" }}
                    inputProps={{ "aria-label": "controlled" }}
                    {...register("isVideoEnabled", {
                      onChange: (e) => {
                        setShowDialog(true);
                      },
                    })}
                  />
                </div>

                {errors.isVideoEnabled && (
                  <>
                    <div className="createVisitFlexEnd">
                      <div className="createVisitError">
                        <span className="error-text" style={{ color: "red" }}>
                          {errors.isVideoEnabled.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}

                <div className="createVisitInput">
                  <p style={labelStyles}>
                    Sequence
                    <span className="error-highlight">*</span>
                  </p>
                  <TextField
                    type={"number"}
                    style={textBoxBody}
                    inputProps={{
                      style: textBoxStyles,
                      min: 0,
                    }}
                    {...register("sequence", {
                      onChange: (e) => {
                        setShowDialog(true);
                      },
                    })}
                  />
                </div>
                {errors.sequence && (
                  <>
                    <div className="createVisitFlexEnd">
                      <div className="createVisitError">
                        <span className="error-text" style={{ color: "red" }}>
                          {errors.sequence.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}

                <Row style={rowStyles}>
                  <Col md={8}></Col>
                  <Col md={2}>
                    <div className="study-management-head-end">
                      <button
                        onClick={(e) => {
                          handleCancel(e);
                        }}
                        className="study-management-cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="study-management-head-end">
                      <button
                        type="submit"
                        className="study-management-create-btn-md"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Box>
        </div>
      )}
    </>
  );
};

export default CreateQuestionnaires;
